module.exports = __webpack_public_path__ + "img/cbl2rr1.ff503b74.gif";